export const TRUST_CENTER_HERO = {
  title: "Trust Center",
  subtitle:
    "Lesson Launchpad™ is committed to protecting student and educator data through secure infrastructure, privacy-first design, and transparent practices.",
};

export const TRUST_CENTER_BADGES = [
  "FERPA Aligned",
  "COPPA Aligned",
  "Student Data Never Sold",
  "Encrypted in Transit",
  "Encrypted at Rest",
  "Google Cloud Infrastructure",
];

export const STUDENT_PRIVACY = {
  title: "Student Data Protection",
  intro:
    "Lesson Launchpad is designed with student privacy in mind. We collect only the data necessary to provide classroom functionality and do not sell student data or use it for targeted advertising.",
  bullets: [
    "Student data is never sold.",
    "No targeted advertising.",
    "Data used only to provide educational services.",
    "Districts retain ownership of their data.",
    "Data deletion available upon request.",
  ],
};

export const SECURITY_PRACTICES = {
  title: "Security Practices",
  bullets: [
    "Encryption in transit (HTTPS/TLS)",
    "Encryption at rest through Google Cloud",
    "Firebase Authentication",
    "Role-based access controls",
    "Firestore security rules",
    "Secure cloud hosting",
    "Rate limiting on sensitive public forms",
    "Internal audit logging for administrative operations",
    "Documented incident response procedures",
  ],
};

export const BREACH_NOTIFICATION = {
  title: "Data Breach Notification",
  body:
    "If we discover a data breach that has compromised personally identifiable information, we will notify affected schools, districts, and users without unreasonable delay and no later than 48 hours after discovery. We will comply with any shorter period required by applicable law.",
};

export const COMPLIANCE_CARDS = [
  {
    id: "ferpa",
    title: "FERPA",
    body:
      "Lesson Launchpad follows practices aligned with the Family Educational Rights and Privacy Act (FERPA). Student information is used only to support classroom tools that educators control.",
  },
  {
    id: "coppa",
    title: "COPPA",
    body:
      "Lesson Launchpad follows practices aligned with the Children's Online Privacy Protection Act (COPPA). The service is not directed to children under 13, and we do not knowingly collect personal information from children under 13.",
  },
  {
    id: "dpa",
    title: "Student Data Privacy Agreements (DPA)",
    body:
      "Lesson Launchpad is willing to execute district Data Privacy Agreements (DPAs) and works with schools to satisfy local procurement requirements.",
  },
];

export const DATA_RETENTION = {
  title: "Data Retention & Deletion",
  bullets: [
    "Schools retain ownership of their data.",
    "Accounts may request export or deletion of their data.",
    "Deleted data is removed according to retention policies.",
  ],
  note:
    "After subscription cancellation, account data may be retained for a limited period before deletion, consistent with our Privacy Policy.",
};

export const SUBPROCESSORS = [
  {
    provider: "Google Cloud / Firebase",
    purpose: "Authentication, database, storage, and cloud functions",
  },
  {
    provider: "Stripe",
    purpose: "Payment processing and subscription billing",
  },
  {
    provider: "Netlify",
    purpose: "Web application hosting",
  },
  {
    provider: "Meta (Facebook Pixel)",
    purpose: "Marketing attribution",
  },
  {
    provider: "FullStory",
    purpose: "Session analytics (present, share, and roster-editing routes excluded; roster displays blocked)",
  },
  {
    provider: "Sentry",
    purpose: "Error monitoring and error-triggered session replay (admin, billing, share, and roster-editing routes excluded; roster displays blocked)",
  },
  {
    provider: "Canva",
    purpose: "Optional Canva integration for content creation",
  },
  {
    provider: "Google Gmail API",
    purpose: "Admin support inbox integration",
  },
  {
    provider: "Mailchimp",
    purpose: "Email list signup (legacy show registration page)",
  },
];

export const TRUST_DOCUMENTS = [
  {
    id: "privacy-policy",
    title: "Privacy Policy",
    href: "/privacy",
    available: true,
    actionLabel: "View policy",
  },
  {
    id: "terms-of-service",
    title: "Terms of Service",
    href: null,
    available: false,
    actionLabel: "View terms",
  },
  {
    id: "data-processing-agreement",
    title: "Data Processing Agreement",
    href: null,
    available: false,
    actionLabel: "Download DPA",
  },
  {
    id: "incident-response-plan",
    title: "Incident Response Plan",
    href: null,
    available: false,
    actionLabel: "Download plan",
  },
  {
    id: "security-overview",
    title: "Security Overview",
    href: null,
    available: false,
    actionLabel: "View overview",
  },
  {
    id: "student-data-deletion-policy",
    title: "Student Data Deletion Policy",
    href: null,
    available: false,
    actionLabel: "View policy",
  },
];

export const TRUST_CONTACT = {
  title: "Questions about security or privacy?",
  emails: [
    { label: "security@lessonlaunchpad.com", href: "mailto:security@lessonlaunchpad.com" },
    { label: "support@lessonlaunchpad.com", href: "mailto:support@lessonlaunchpad.com" },
  ],
};

export const FUTURE_ENHANCEMENTS = [
  { id: "soc2", label: "SOC 2 certification", available: false },
  { id: "security-audit-reports", label: "Security audit reports", available: false },
  { id: "status-page", label: "Public status page", available: false },
  { id: "dpa-downloads", label: "DPA downloads", available: false },
  { id: "district-approvals", label: "District approvals", available: false },
  { id: "penetration-testing", label: "Penetration testing reports", available: false },
];

export function getAvailableTrustDocuments() {
  return TRUST_DOCUMENTS.filter((document) => document.available);
}

export function getPlannedFutureEnhancements() {
  return FUTURE_ENHANCEMENTS.filter((item) => !item.available);
}
